import { render } from "./RegisterProjectView.vue?vue&type=template&id=c3135174&scoped=true&ts=true"
import script from "./RegisterProjectView.vue?vue&type=script&lang=ts"
export * from "./RegisterProjectView.vue?vue&type=script&lang=ts"

import "./RegisterProjectView.vue?vue&type=style&index=0&id=c3135174&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3135174"]])

export default __exports__